const telephone = {
  	bindings: {
  	  value: '@'
  	},
  	template: '<a href="tel:{{ $ctrl.value }}">{{ $ctrl.value }}</a>'
};

export default telephone;



/** WEBPACK FOOTER **
 ** ./src/app/directives/common/telephone.js
 **/